import styles from './Skeleton.module.scss';
import SkeletonElement from './SkeletonElement';
import Shimmer from './Shimmer';

export default function SkeletonPickupLocation() {
  return (
    <div className={styles.wrapper}>
      <div className={styles.pickupLocation}>
        <SkeletonElement type="thumbnail" />

        <div className={styles.contentWrapper}>
       
          <SkeletonElement type="textSmall" />
          <SkeletonElement type="title" className="mb-100" />
          <SkeletonElement type="text" />
          <SkeletonElement type="text" />

          <SkeletonElement type="text" />
          <SkeletonElement type="text" />
          <SkeletonElement type="text" />
      
   
          <SkeletonElement type="button" className="w-100"/>
          <SkeletonElement type="button" className="w-100" />
     
        </div>
      </div>
      <Shimmer />
    </div>
  );
}